import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { BookingsApiKeyComponent }           from './bookings.api-key.component';
import { BookingsApiSecretKeyComponent }     from './bookings.api-secret-key.component';
import { BookingsAppointmentTypeComponent }  from './bookings.appointment-type.component';
import { BookingsRequestActionsComponent }   from './bookings.request.actions.component';
import { BookingsRequestComponent }          from './bookings.request.component';
import { BookingsRequestsComponent }         from './bookings.requests.component';
import { BookingsRequestSendEmailComponent } from './bookings.request.send-email.component';
import { BookingsRequestSendSmsComponent }   from './bookings.request.send-sms.component';
import { BookingsService }                   from './bookings.service';
import { BookingsSettingsComponent }         from './bookings.settings.component';
import { BookingsStates }                    from './bookings.states';
import { ProductsModule }                    from '../products/products.module';
import { SharedModule }                      from '../shared/shared.module';
import { TableModule }                       from '../table/table.module';

@NgModule({
  declarations: [
    BookingsApiKeyComponent,
    BookingsApiSecretKeyComponent,
    BookingsAppointmentTypeComponent,
    BookingsRequestActionsComponent,
    BookingsRequestComponent,
    BookingsRequestsComponent,
    BookingsRequestSendEmailComponent,
    BookingsRequestSendSmsComponent,
    BookingsSettingsComponent
  ],
  entryComponents: [
    BookingsApiKeyComponent,
    BookingsApiSecretKeyComponent,
    BookingsAppointmentTypeComponent,
    BookingsRequestActionsComponent,
    BookingsRequestComponent,
    BookingsRequestsComponent,
    BookingsRequestSendEmailComponent,
    BookingsRequestSendSmsComponent,
    BookingsSettingsComponent
  ],
  imports: [
    ProductsModule,
    SharedModule,
    TableModule,

    UIRouterUpgradeModule.forChild({ states: BookingsStates })
  ],
  providers: [
    BookingsService
  ]
})
export class BookingsModule {}
